import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { environment } from '../../environments/environment';
import { CopyContentDialogComponent } from '../shared/copy-content-dialog/copy-content-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  public isSafari:boolean = false;
  constructor(public notifier: NotifierService,public copyDialogRef: MatDialog) { }

  getSubStr(str, length, endLength?:number){
    if (!str) {
      return '';
    } else if (endLength) {
      if (str.length > (length + endLength)) {
        return str.substring(0, length) + '...' + str.substring(str.length - endLength);
      } else {
        return str;
      }
    } else if (str.length > length) {
      if (str.substring(0, 10) == '----------') {
        return str;
      } else {
        return str.substring(0, length) + '...';
      }
    } else {
      return str;
    }

  }

  copyOnClick(str:string){
      if(navigator.userAgent.indexOf("Safari") > -1 && !(navigator.userAgent.indexOf("Chrome") > -1)){
        this.isSafari = true;
      }

      if(!this.isSafari) {
        this.notifier.notify('success','Copied to clipboard!');
        let textarea = document.createElement('textarea');
        textarea.setAttribute('type', 'hidden');
        textarea.textContent = str;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      } else {
        this.openCopyUrlDialog(str)
        // const dialogRef = this.Dialoge.open(ClickToCopyComponent,{centered: true}); 
        // dialogRef.componentInstance.data = {"text":str}
      }
  }

  openCopyUrlDialog(str) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.width = '350px',
    dialogConfig.data = {
        content: str
    };
    this.copyDialogRef.open(CopyContentDialogComponent, dialogConfig)
  }
  
}